import { Component, OnInit,TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { OpenApiService } from '../services/open-api.service';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  footerData: any;
  modalRef: BsModalRef;
  contentReceived: any;
  domain:any
  constructor(private modalService: BsModalService,private open : OpenApiService) {
    this.domain = window.location.hostname;
   }

  ngOnInit(): void {
    this.footerContent();
  }
  footerContent(){
    this.open.footerContent().subscribe((res) => {
      if(res.status){
        this.footerData = res.data;
      }
    }) 
  }
  openModalLoginCnfm(param,loginCnfm: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      loginCnfm,
      Object.assign({}, { class: 'loginCnfm-modal',ignoreBackdropClick: true })
    );
    let data ={ 
      slug :  param
    }
    this.open.popUpContent(data).subscribe((res)=> {
      if(res.status){
        this.contentReceived = res.data.description;
      }
    })
  }
}
